import { connect } from '../../store';

var selectFormState = function selectFormState(formState) {
  return {
    dirty: formState.fields.some(function (field) {
      return field.dirty;
    }),
    error: formState.error
  };
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    formState: state.getIn(['forms', props.formKey], null)
  };
};

var FormStateComopnent = function FormStateComopnent(props) {
  return props.formState && props.children(selectFormState(props.formState));
};

export var FormState = connect(mapStateToProps)(FormStateComopnent);